(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/core/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/numbergames/core/assets/javascripts/prescript.js');

'use strict';

svs.numbergames = svs.numbergames || {};
svs.numbergames.core = svs.numbergames.core || {};
svs.numbergames.core.behaviors = svs.numbergames.core.behaviors || {};
svs.numbergames.core.utils = svs.numbergames.core.behaviors || {};
svs.numbergames.core.logger = new svs.core.log.Logger('numbergames:models');

 })(window);